import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Icon from "@client.components/Icon";
import config from "@client.config";
import { useDispatch } from "react-redux";
import { processLoginAsync } from "@client.pages/Login/reducer";

const GoogleLogin = ({ hide }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(window.location.search);
  const email = queryParams.get("g");
  const token = queryParams.get("t");

  const handleLogin = () => {
    const clientId = config.google.clientId;
    const redirectUri = `${config.apiUrl}/google/auth`;
    const scope =
      "email profile openid https://www.googleapis.com/auth/admin.directory.group.readonly https://www.googleapis.com/auth/calendar.readonly";
    const state = window.location.host.split(".")[0];
    const googleAuthUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${state}&prompt=select_account`;
    window.location.href = googleAuthUrl;
  };

  useEffect(() => {
    if (email && token) {
      dispatch(
        processLoginAsync({
          email,
          token,
          isGoogle: true,
        })
      );
    }
  }, [dispatch, email, token]);

  return (
    !hide && (
      <>
        <button className="google" onClick={handleLogin}>
          <Icon name="google" />
          {t("components.GoogleLogin.signin")}
        </button>
      </>
    )
  );
};

GoogleLogin.propTypes = {
  hide: PropTypes.bool,
};

export default GoogleLogin;
